<template>
    <div class="container-fluid mt-7">
        <div class="card">
            <base-header class="pb-6 bg-white">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 d-inline-block mb-0">Technical System</h6>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-3 col-md-3 col-md-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ serverActive }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Server Active Sessions
                                </h4>
                                <p class="mb-0 opacity-8 text-white h6">Count of currently active connections to the
                                    server</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-md-3 col-md-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ serverRejected }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Server Rejected Sessions
                                </h4>
                                <p class="mb-0 opacity-8 text-white h6">Count of connections denied by the server</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-md-3 col-md-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ systemCpuUsage }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">System Cpu Usage
                                </h4>
                                <p class="mb-0 opacity-8 text-white h6">The percentage of CPU capacity in use.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-md-3 col-md-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ proceessCpuUsage }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase"> Process Cpu Usage
                                </h4>
                                <p class="mb-0 opacity-8 text-white h6">The percentage of CPU used by a process.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-8 col-md-12 col-lg-12">
                        <gcPauseDetail></gcPauseDetail>
                    </div>
                    <div class="col-xl-4 col-md-12">
                        <card header-classes="bg-transparent">
                            <template v-slot:header>
                                <h5 class="h3 mb-0">Jvm Memory Usage</h5>
                            </template>
                            <div>
                                <canvas :height="260" :id="doughnetChartID"></canvas>
                            </div>
                        </card>
                    </div>
                    <div class="col-xl-8 col-md-12 col-lg-12">
                        <gcMemoryUsage></gcMemoryUsage>
                    </div>
                    <div class="col-xl-4 col-md-12 col-lg-12">
                        <memoryUsageDetail></memoryUsageDetail>
                    </div>
                    <div class="col-xl-8 col-md-12 col-lg-12">
                        <serverSessionDetail></serverSessionDetail>
                    </div>
                    <div class="col-xl-4 col-md-12">
                        <card header-classes="bg-transparent">
                            <template v-slot:header>
                                <h5 class="h3 mb-0">Threads</h5>
                            </template>
                            <div>
                                <canvas :height="340" :id="ordersChartID"></canvas>
                            </div>
                        </card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-6 col-md-12 col-lg-12">
                        <cpuUsageDetail></cpuUsageDetail>
                    </div>
                    <div class="col-xl-6 col-md-12 col-lg-12">
                        <jvmMemoryUsage></jvmMemoryUsage>
                    </div>
                </div>
            </base-header>
        </div>
    </div>
</template>
<script>
import memoryUsageDetail from "./MemoryUsage";
import serverSessionDetail from "./ServerSessionDetail.vue";
import cpuUsageDetail from "./CpuUsageDetail.vue";
import gcMemoryUsage from "./GcMemoryUsage.vue";
import gcPauseDetail from "./GcPauseDetail.vue";
import jvmMemoryUsage from "./JvmMemoryUsage.vue";
export default {
    components: {
        memoryUsageDetail,
        serverSessionDetail,
        cpuUsageDetail,
        gcMemoryUsage,
        gcPauseDetail,
        jvmMemoryUsage
    },
    data() {
        return {
            serverActive: "",
            systemCpuUsage: "",
            proceessCpuUsage: "",
            deamonProcess: "",
            liveProcess: "",
            processState: "",
            peakProcess: "",
            connection: "",
            memoryCommited: "",
            memoryUsed: "",
            doughnetChartID: "doughnetChart",
            ordersChartID: "ordersChartId",
        };
    },
    methods: {
        formatValue(value) {
            if (value >= 100 && value < 100000) {
                return (value / 1000).toFixed(2) + 'k';
            } else if (value >= 100000 && value < 10000000) {
                return (value / 100000).toFixed(2) + 'L';
            }
            else if (value >= 10000000) {
                return (value / 10000000).toFixed(2) + 'CR';
            }
            return value;
        },
        createOrderChart() {
            const ctx = document.getElementById(this.ordersChartID).getContext("2d");
            if (this.orderChart) {
                this.orderChart.destroy();
            }
            this.orderChart = new Chart(ctx, {
                type: "bar",
                data: {
                    labels: ["Deamon", "Live", "Peak", "Runnable"],
                    datasets: [
                        {
                            label: "Count",
                            tension: 0.4,
                            borderWidth: 0,
                            pointRadius: 0,
                            backgroundColor: ["#281483", "#8f6ed5", "#76eea7", "#1fa2ff"],
                            data: [this.deamonProcess, this.liveProcess, this.peakProcess, this.processState],
                            maxBarThickness: 15,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: true,
                        mode: "index",
                        intersect: false,
                    },
                    scales: {
                        yAxes: [
                            {
                                gridLines: {
                                    borderDash: [2],
                                    borderDashOffset: [2],
                                    zeroLineColor: "#dee2e6",
                                    drawBorder: false,
                                    drawTicks: false,
                                    lineWidth: 1,
                                    zeroLineWidth: 1,
                                    zeroLineBorderDash: [2],
                                    zeroLineBorderDashOffset: [2],
                                },
                                ticks: {
                                    beginAtZero: true,
                                    padding: 10,
                                    fontSize: 13,
                                    fontColor: "#8898aa",
                                    fontFamily: "Open Sans",
                                    callback: function (value) {
                                        if (!(value % 10)) {
                                            return value;
                                        }
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    drawOnChartArea: false,
                                    drawTicks: false,
                                },
                                ticks: {
                                    padding: 20,
                                    fontSize: 13,
                                    fontColor: "#8898aa",
                                    fontFamily: "Open Sans",
                                },
                            },
                        ],
                    },
                },
            });
        },
        createDoughnetChart() {
            const ctx = document.getElementById(this.doughnetChartID).getContext("2d");
            if (this.doughnetChart) {
                this.doughnetChart.destroy();
            }
            this.doughnetChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                    labels: ["Used", "Free"],
                    datasets: [
                        {
                            label: "Dataset 1",
                            tension: 0.4,
                            data: [this.memoryUsed, (this.memoryCommited - this.memoryUsed).toFixed(2)],
                            backgroundColor: [
                                "#3b5999",
                                "#2dce89",
                                "#2dce89",
                                "#5e72e4",
                                "#11cdef",
                            ],
                            showLine: false,
                            barPercentage: 1.6,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 50,
                    rotation: Math.PI,
                    circumference: 2 * Math.PI,
                    legend: {
                        display: true,
                        position: "bottom",
                        labels: {
                            boxWidth: 20,
                            font: { size: 14, weight: "bold" },
                        },
                    },
                    tooltips: {
                        enabled: true,
                        mode: "index",
                        intersect: false,
                    },
                    scales: {
                        display: false,
                        yAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "transparent",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    display: false,
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "transparent",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    display: false,
                                },
                            },
                        ],
                    },
                    pluginLabels: {
                        Commited: this.memoryCommited,
                    },
                    layout: {
                        padding: 5,
                    },
                },
                plugins: [
                    {
                        afterDraw: function (chart) {
                            const { ctx, width, height } = chart;
                            const pluginLabels = chart.options.pluginLabels;
                            const committedValue = pluginLabels.Commited || "N/A";
                            const centerX = width / 2;
                            const centerY = height / 2.4;
                            ctx.font = "bold 18px Open Sans";
                            ctx.textAlign = "center";
                            ctx.textBaseline = "middle";
                            ctx.fillStyle = "#8898aa";
                            ctx.fillText(`${committedValue} GB`, centerX, centerY);
                        },
                    },
                    {
                        id: "sectionLabels",
                        afterDraw: (chart) => {
                            const { ctx } = chart;
                            const meta = chart.getDatasetMeta(0);
                            ctx.textBaseline = "middle";
                            ctx.textAlign = "center";
                            meta.data.forEach((element, index) => {
                                const model = element.tooltipPosition();
                                const value = parseFloat(chart.data.datasets[0].data[index]);
                                if (value === 0 || value < 0.03) return;
                                let fontSize = 14;
                                let fontColor = "#ffffff";
                                if (value < 0.08) {
                                    ctx.save();
                                    ctx.translate(model.x, model.y);
                                    ctx.fillStyle = "#ffffff";
                                    ctx.font = "bold 12px sans-serif";
                                    ctx.fillText(`${value}GB`, 0, 0);
                                    ctx.restore();
                                } else {
                                    ctx.fillStyle = fontColor;
                                    ctx.font = `bold ${fontSize}px sans-serif`;
                                    ctx.fillText(`${value}GB`, model.x, model.y);
                                }
                            });
                        },
                    },
                ],
            });
        },
        getServerActiveCurrent(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.serverActive = JSON.parse(response.server.data[0].value);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getServerRejected(type) {
            let data = {
                type: type,
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.serverRejected = response.server.data[0].value;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatTime(seconds) {
            if (seconds < 60) {
                return `${seconds}s`;
            } else if (seconds < 3600) {
                const minutes = Math.floor(seconds / 60);
                return `${minutes}m`;
            } else {
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
                return `${hours}h ${formattedMinutes}m`;
            }
        },
        getSystemCpuUsage(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.systemCpuUsage = response.server.data[0].value.toFixed(3);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getProcessCpuUsage(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.proceessCpuUsage = response.server.data[0].value.toFixed(3);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getDeamonProcess(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.deamonProcess = response.server.data[0].value;
                    this.createOrderChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getLiveProcess(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.liveProcess = response.server.data[0].value;
                    this.createOrderChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getPeakProcess(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.peakProcess = response.server.data[0].value;
                    this.createOrderChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getProcessState(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.processState = response.server.data[0].value;
                    this.createOrderChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getMemoryCommited(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    const bytes = response.server.data[0].value;
                    this.memoryCommited = this.formatBytes(bytes);
                    this.createDoughnetChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getGcMemoryUsed(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    const bytes = response.server.data[0].value;
                    this.memoryUsed = this.formatBytes(bytes);
                    this.createDoughnetChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatBytes(bytes) {
            const gigabytes = bytes / (1024 ** 3);
            const formattedGB = gigabytes.toFixed(2);
            return formattedGB;
        }
    },
    mounted() {
        this.getProcessCpuUsage("PROCESS_CPU_USAGE");
        this.getServerRejected("SERVER_SESSION_REJECTED");
        this.getServerActiveCurrent("SERVER_SESSION_CURRENT")
        this.getSystemCpuUsage("SYSTEM_CPU_USAGE");
        this.getDeamonProcess("DEAMON_PROCESSES");
        this.getLiveProcess("LIVE_PROCESSES");
        this.getPeakProcess("PEAK_PROCESSES");
        this.getProcessState("PROCESS_STATES");
        this.getMemoryCommited("MEMORY_COMMITED");
        this.getGcMemoryUsed("MEMORY_USED");
    },
};
</script>
